import { CartAddEvent, CartErrorEvent } from "@theme/events";
import { fetchConfig } from "@theme/utilities";

function showUpsellError(card, message, { tone = "error" } = {}) {
  if (!(card instanceof HTMLElement)) return;
  let slot = card.querySelector("[data-upsell-error]");
  if (!slot) {
    slot = document.createElement("p");
    slot.setAttribute("data-upsell-error", "");
    slot.setAttribute("role", "alert");
    card.querySelector(".dd-pinch-upsell__body")?.appendChild(slot);
  }
  slot.className =
    tone === "warning"
      ? "dd-pinch-upsell__error dd-pinch-upsell__error--warning"
      : "dd-pinch-upsell__error";
  slot.textContent = message;
  slot.hidden = false;
}

function clearUpsellError(card) {
  const slot = card?.querySelector?.("[data-upsell-error]");
  if (slot) {
    slot.textContent = "";
    slot.hidden = true;
  }
}

document.addEventListener("submit", async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (form.dataset.type !== "cart-upsell-add") return;

  event.preventDefault();

  const card = form.closest("[data-upsell-card]");
  const button = form.querySelector('button[type="submit"]');

  clearUpsellError(card);
  if (button instanceof HTMLButtonElement) button.disabled = true;
  card?.classList.add("is-adding");

  const sectionsToUpdate = new Set();
  document.querySelectorAll("cart-items-component").forEach((element) => {
    const sectionId =
      element instanceof HTMLElement ? element.dataset.sectionId : null;
    if (sectionId) sectionsToUpdate.add(sectionId);
  });

  const formData = new FormData(form);
  const payload = {
    items: [
      {
        id: Number(formData.get("id")),
        quantity: Number(formData.get("quantity")) || 1,
      },
    ],
    sections_url: window.location.pathname,
  };

  if (sectionsToUpdate.size > 0) {
    payload.sections = Array.from(sectionsToUpdate).join(",");
  }

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      ...fetchConfig("json"),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(
        error.description || `Add to cart failed (${response.status})`,
      );
    }

    const data = await response.json();
    let cart = null;

    try {
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: "application/json" },
      });

      if (cartResponse.ok) {
        cart = await cartResponse.json();
      }
    } catch (error) {
      console.warn("Cart upsell cart refresh failed:", error?.message ?? error);
    }

    document.dispatchEvent(
      new CartAddEvent(cart ?? data, form.id, {
        source: "cart-upsell",
        itemCount: cart?.item_count ?? data.item_count,
        productId: data.items?.[0]?.product_id ?? data.product_id,
        variantId: data.items?.[0]?.variant_id ?? data.variant_id,
        sections: data.sections,
      }),
    );

  } catch (error) {
    const message = error?.message ?? "Couldn't add that right now. Try again.";
    console.error("Cart upsell add error:", message);
    showUpsellError(card, message);
    document.dispatchEvent(new CartErrorEvent(form.id, message, message, null));
  } finally {
    if (button instanceof HTMLButtonElement) button.disabled = false;
    card?.classList.remove("is-adding");
  }
});
